module.exports = __webpack_public_path__ + "img/icon1.ef9336a1.png";